import  React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon from '../../icons';
import FieldRenderingEngine from "../FieldRenderingEngine";
import { getResolutionName } from '../../containers/WorkkardDetail/utils';
import AddEditActivity from '../../containers/CreationForms/AddEditActivity';
import ChoseReason from '../ChoseReason';
import { updateActivityField } from '../../containers/WorkkardDetail/actions/action';
import InlineEditableField from '../InlineEditableField';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';
var momentTz = require('moment-timezone');


    
    
const ActivityDetail = (props) => {
    const [activityDetail,setActivityDetail]=useState("");
    let activityDetailRef =useRef(null)
    const activityData= useSelector(state => state.workkardDetail.activityDetail);
    const isLoading= useSelector(state => state.workkardDetail.detailPage.isLoading);
    const workkard = useSelector(state => state.workkardDetail.workkardDetail);
    const dispatch =useDispatch();
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    const userPermission = userView?.permissions;

    const isWorkkardClosedForOrg = () =>
        workkard?.WorkkardStatus?.toUpperCase() === 'CLOSE'
        && workkard?.OrganizationId === userView?.orgId;

    useEffect(() => {
          
        document.addEventListener('mousedown', handleOutsideClick);
        if (activityData !== activityDetail) {
            setActivityDetail(activityData);
        }
          return () => {
         
        document.removeEventListener('mousedown', handleOutsideClick);
          }
        }, [activityData])
    const onClose = ()=> {
        if (isLoading) {
            return
        }
        props.onClose();
    }
        
    const handleOutsideClick = (event) => {
        if (activityDetailRef && !activityDetailRef.current.contains(event.target) && !props.hasOwnProperty('canEdit')) {
            onClose();
        }
    }
    
    const  updateActivityFields = (data) => {
        const payload = {
            hdnActId: activityData.activityId,
            callback: () => onSuccess(),
        }
        let combinedPayload = Object.assign({}, payload, data);
        dispatch(updateActivityField(combinedPayload));
    }

        
        const removeErrorOnFocus = (e) => {
            if (!$('#' + e.target.name + 'errorBlock').is(':empty')) {
                $('#' + e.target.name + 'errorBlock').text('');
            }
        }
        
        const renderCustomFields = (objprops) => {
            if (activityData && activityData.customFields && activityData.customFields.length) {
                return (
                    <FieldRenderingEngine
                        data={activityData.customFields}
                        userTimezone={sessionContext.TimeZoneTz}
                        tzData={sessionContext.tzData}
                        renderLocation="detail"
                        renderType="activity"
                        canEditActivity={props.canEdit ? props.canEdit : false}
                        updateActivityField={(data) => updateActivityFields(data)}
                        excludeFields={objprops.excludeFields ?? []}
                        showLabel={objprops.showLabel ?? false}
                    />
                );
            }
            return "";
        }
        
        const handleEditActivity = (actId, wkId) => {
            if (isWorkkardClosedForOrg()) {
                return dispatch(props.showDialogueBox({
                    flag: true,
                    component: (
                        <ChoseReason
                            title="Edit Activity"
                            isEditActivity={true}
                            wkid={wkId}
                            actId={actId}
                            onClose={closeDialogBox}
                            onConfirmClick={({ reasonId, subReasonId }) =>
                                dispatch(props.showDialogueBox({
                                    flag: true,
                                    component: (
                                        <AddEditActivity
                                            isEdit={true}
                                            onClose={closeDialogBox}
                                            workkardId={wkId}
                                            actId={actId}
                                            wrrId={reasonId}
                                            wrkdReopenSubreasonId={subReasonId}
                                        />
                                    ),
                                    overlayClassName: "modal animated faster fadeIn",
                                    contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
                                    shouldCloseOnOverlayClick: true,
                                }))
                            }
                        />
                    ),
                    overlayClassName: "modal animated faster fadeIn",
                    contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 small",
                    shouldCloseOnOverlayClick: true,
                }))
            }
            return dispatch(props.showDialogueBox({
                flag: true,
                component: <AddEditActivity isEdit={true} onClose={closeDialogBox} workkardId={wkId} actId={actId} />,
                overlayClassName: "modal animated faster fadeIn",
                contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
                shouldCloseOnOverlayClick: true,
            }))
        }
        
        const closeDialogBox = () => {
            dispatch(props.hideDialogueBox());
        }
        
        const getPreSaveScript = (date) => {
            if (date) {
                var dateFormat = $("#cuDynamicDatePattern").length ? $("#cuDynamicDatePattern").val().toUpperCase() : "MM/DD/YYYY";
                var flag;
                var dueDate = moment(date, dateFormat)._d;
                var cDate = moment().subtract(1, 'days')._d
                if (dueDate) {
                    flag = (cDate < dueDate);
                    if (!flag) {
                        $("[id^=dueDateerrorBlock]").text("Invalid Date.");
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            }
        }
        
        const toEpochMs = (epoch) => {
            if (epoch == null) return epoch;
            return epoch.toString().length <= 10 ? epoch * 1000 : epoch;
        }

        const timezoneOptions = (sessionContext.tzData || []).map((tz) => ({
            Id: tz.standard_time_zone,
            UniversalTimeZoneId: tz.standard_time_zone,
            DisplayText: tz.display_value,
        }));

        const getCombinedData = () => {
            const matchedTz = (sessionContext.tzData || []).find(item => item?.standard_time_zone === activityDetail.dueDateTz);
            let data = [
                {
                    FieldKey: "dueDate", Name: "dueDate", IsNonEditable: false, disabled:getValue(activityDetail.resolution), Label: "Activity Due Date", IsRequired: true, Value: momentTz.utc(toEpochMs(activityDetail.dueDate)).tz(activityDetail.dueDateTz),
                    FieldType: "datetime", PreSaveScript:!getValue(activityDetail.resolution)  ? `var verifyValidations = ${getPreSaveScript.toString()};verifyValidations($("[id^=dueDate]").val());` : null, FieldSettings: JSON.stringify({ input_time_component: true, output_time_component: true })
                },
                {
                    FieldKey: "dueDateTzDll", Name: "dueDateTzDll", IsNonEditable: false, Label: "Activity Due Date", IsRequired: true,
                    Value: matchedTz?.display_value,
                    FieldType: "timezone", PreSaveScript: null, FieldSettings: JSON.stringify({ timezone_iseditable: true })
                }
            ]
            return data;
        }
        
        const getValue = (resoln) => {
        if((resoln=="InProgress" || resoln=="Assigned" || resoln=="ReAssigned" || resoln=="Accepted" || resoln=="ReOpened" || resoln=="Open")
        && ((activityDetail.activityOwnerId == userView.id) || (userPermission.can_create_activity || userPermission?.can_edit_activity && (activityDetail.ownerOrgId == userView.orgId)))){
        return false
        }
        return true
        }

    if (activityDetail) {
        return (  <div ref={activityDetailRef}>
                        <div className="modalHeader alignMiddle" >
                            <h2 className="flexGrow alignBase flexWrap rowFlex">
                                <span className="mr">{props.data.activityName}</span>
                                <span className={`status statusSizeSmall ${getResolutionName(props.data.resolution.toLowerCase(), true)}`}>({getResolutionName(props.data.resolution)})</span>
                                {props.canEditActivity &&
                                    <a className="ml__1" onClick={() =>handleEditActivity(props.data.activityId, props.data.workkardId)} href="javascript:void(0)">
                                        edit
                                    </a>}
                            </h2>
                            <div className="detailClose selfStart">
                                {/* <a className="h__16" onClick={this.props.onFullScreen}><Icon name="expand" className="icon mr__1" /></a> */}
                                <a className="h__16" href="javascript:void(0)" onClick={onClose}><Icon name="close" className="icon" /></a>
                            </div>
                        </div>
                        <div className="modalBody">
                            <div className="wkDetailInfo InlineEditBlock wth-12">
                                    <ul className="rowFlex wrapFlex">
                                        {
                                            renderCustomFields({
                                                excludeFields: ['Customer Name', 'Attach Files'],
                                                showLabel: true
                                            })
                                        }
                                        <li>
                                            <label>Activity Due Date</label>
                                            {
                                                <InlineEditableField
                                                    type="datetimetimezone"
                                                    data={{ FieldKey: "dueDate", Name: "dueDate", IsNonEditable: false, Label: "Activity Due Date", IsRequired: true }}
                                                    Options={timezoneOptions}
                                                    userTimezone={sessionContext.userTimezone}
                                                    fieldValue={activityDetail.dueDateString}
                                                    combinedData={getCombinedData()}
                                                    canEdit={props.canEdit || false}
                                                    isCompositeField={true}
                                                    removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                                                    updateField={(data) => updateActivityFields(data)} />
                                            }
                                        </li>
                                        {activityDetail ? (
                                            <li>
                                                <label>Skillset</label>
                                                {activityDetail.skillset}
                                            </li>
                                        ) : null}
                                    </ul>
                                <ul className="detail mt__1 actDescription">
                                    <li>
                                        <label className="mb__8 mt">Description</label>
                                        {/**
                                    handle the html coming from data
                                */}
                                        <p className="descriptionFormating mb" dangerouslySetInnerHTML={{ __html:activityDetail.activityDescriptionFull }}></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
        );

        }
}
export default ActivityDetail;